const content = {
    footer: {
        primaryLabel: "DISCOVER",
        secondaryLabel1: "Powered by Global Markets",
        secondaryLabel2: "- EY Knowledge",
        logOut: "LOGOUT",
        glossary: "GLOSSARY",
        settings: "SETTINGS",
        support: "SUPPORT",
        sendFeedback: "SEND FEEDBACK"
    },
    homePage: {
        secondaryTitle: "A smart way of finding and evaluating  data",
        searchBoxPlaceholder: "Search for data providers, data products and data sets here",
    },
    homeText: {
        primaryTitle: "Data Explorer",
        titleHint: "Data Explorer Home"
    },
    homeFilter: {
        titlefilter: "Filter your results",

    },
    homeFilter2: {
        linefilter: "|",
    },
    logoutPage: {
        message: "Thank you for your request.",
        logoutStatus: "Success",
        loginBtnLabel: "Login"
    },
    actionPanel: {
        requestLabel: "Request Access",
        toastMsg: "You have successfully copied the URL.",
        shareMsg: "Open - ",
        emailSubject: "Data Explorer - "
    },
    filter: {
        resetBtnLabel: "Clear all"
    },
    navbar: {
        appsLabel: "Apps",
        submitLabel: "Submit",
        submitTooltip: "Submit your material for inclusion in Discover"
    },
    viewMore: {
        viewMoreLable: "view-all",
        viewLessLable: "view-less"
    },
    glossaryPage: {
        title: "Glossary"
    },
    whatsNew: {
        title: "What's New"
    },
    newJoiner: {
        title: "New Joiner"
    },
    viewCart: {
        title: "View Cart"
    },
    details: {
        download: "Download",
        goToProvider: "Go to Data Provider Profile",
        contactTitle: "Support",
        goToWebsite: "Go to Data Provider Website",
    },
    resultPage: {
        noResultTitle: "We could not find any results for your search.",
        noResultDescription: `Suggestions:</br>
      Make sure that all words are spelled correctly.</br>
      Try different keywords.</br>
      Try more general keywords.`,
        noResultInfo: "Please click here to describe your need in more detail.",
        noResulteMailTo: "externalcontent@ey.com",
        noResulteMailSubject: "We could not find any results for your search",
        noResultMailBody: "Please describe your need in more detail.",

    },
    compareViewPage: {
        title: "Compare",
        noItemsMessage: {
            description: "You currently have no items selected to compare in your cart.  Please select one or more assets from your cart to compare."
        }
    },
    pageTitle: {
        homePage: "Data Explorer",
        resultPage: "Results{searchTerm} | In | Data Explorer",
        detailsPage: "{documentTitle} | Data Explorer",
        loginPage: "Data Explorer Login",
        logoutPage: "Data Explorer Logout",
        glossaryPage: "Data Explorer Glossary",
        newJoinerPage: "Data Explorer New Joiner",
        whatsNewPage: "Data Explorer What's New",
        compareViewPage: "Compare View",
        recentViewAllPage: "Recently Viewed",
        clientDataPage: "Data Explorer - Client Data",
    },
    requestAccessPopUp: {
        header: "How data can be used",
        acknowledge: "Acknowledge",
        closed: "Closed",
        user: "Firsttimeuser"
    },
    detailPageNoContent: {
        headerText: "Content not available",
        bodyText: "The link you are accessing is not available. The asset may have been archived, the link is invalid or you don’t have permissions.",
        buttonText: "Search in Data Explorer"
    },
    cartAndComparePopup: {
        label: "View Cart",
        emptyMessage: "Add assets to the cart to compare them side by side",
        compareBtnLabel: "Compare",
        clearAllBtnLabel: "Clear all"
    },
    bannerImage: {
        homeIconHint: "Data Explorer Home"
    },
    ClientDataPage: {
        secondaryTitle: "A smart way of finding and evaluating  data",
        searchBoxPlaceholder: "Search for client or engagement data",
    },
    ClientDataText: {
        primaryTitle: "Data Explorer - Client Data",
        titleHint: "Data Explorer - Client Data Home"
    },
    cardHover: {
        provider: "Data Provider",
        datadelivery: "Data Delivery Method(s)",
        dataProviderImageAlternativeText: "Dataprovider hover background"
    },
    dropdownmenu: {
        AddtoCart: "Add to Cart",
        Copyurl: "Copy URL",
        SendanEmail: "Send an Email",
        ChatinTeams: "Share to Teams"

    },
    expandAndCollapse: {
        title: "title"
    },
    viewmore: {
        title: "View More"
    },
    viewAll: {
        title: "View all"
    },
    toggleButtonVisiblity: {
        mostPopular: 'mostpopular',
        topic: 'topic',
        recentlyviewAll: 'recentlyviewedall',
        recentlyviewed: 'recentlyviewed',
        resultpage: 'resultpage',
        listpage: 'listpage'
    },
    viewType: {
        listview: 'listview',
        cardview: 'cardview'
    },
    // Release 29.5: added seach query filter by path
    listNames: {
        TDFDiscoverDataSets: "TDFDiscoverDataSets",
        DiscoverDataAsset: "DiscoverDataAsset",
        TDFDiscoverDataCollateral: "TDFDiscoverDataCollateral",
        DiscoverDataCollateral: "DiscoverDataCollateral"
    },
    paths: {
        displayForm: "/DispForm.aspx?ID="
    },
    ApiRowLimit: {
        popular: 4,
        recentlyView: 12,
        searchResult: 12
    },
    contactListName: {
        DataAssetContactListName: "Data Asset Contact",
        TDFContactListName: "TDF Contact",
    },
    contactFields: {
        DataAsset: "DataAsset",
        TDFDataAsset: "TDFDataAsset",
        categoryDetails: "categoryDetails"
    },
    registrationModel: {
        title: "First Time User Access",
        columnField: 'EYKDRegistration'
    },
    recentlyviewedtype: {
        type: "recentlyviewed"
    },
    firstTimeAccess: {
        line1: "If this is your first time accessing this data source",
        line2: "If you have access, click the {buttonLabel} button."
    },
    Assetpills: {
        All: "All",
        Products: "Products",
        Providers: "Providers",
        Sets: "Sets",
        managedProperty: 'EYKDAssetType'
    },
    ApiResponseStatus: {
        start: "START",
        progressing: "PROGRESSING",
        done: "DONE"
    },
    pathContent: {
        homePgae: "HomePage",
        results: "results",
        Results: "Results",
        search: "SearchPage",
        recentlyViewAll: "recentlyViewAll",
        recentlyViewAllPage: "RecentlyviewAllPage",
        recentlyViewPage: "Recentlyviewed Page",
        recentlyViewed: "Recentlyviewed",
        copyBitlyLink: "Copy Bitly Link",
        email: "Email",
        shareTeam: "Share to Teams",
        mostpopular: "Mostpopular"
    },
    ellipsis: {
        homePage: "Homepage",
        recentlyViewed: "Recently Viewed",
        copyBitlyLink: "Copy URL",
        email: "Send an Email",
        shareTeam: "Share to Teams",
        mostpopular: "Most popular",
        addToCart: "Add to Cart",
        searchResults: "Search Results",
    },
    contactType: {
        TDFContact: "TDFContact",
        PeopleContact: "PeopleContact",
        EmailContact: "EmailContact",
        LinkContact: "LinkContact"
    },
    roleDescription: {
        roleMaxCharLength: 24
    },
    clientdataFilters: {
        filterKeys: ["owstaxIdEYKDCategory", "owstaxIdEYKDSector", "owstaxIdEYKDServiceLine"]
    },
    ackPopUp: {
        title: "Usage Terms & Conditions",
        message1: "I acknowledge that I have read and accepted the Terms & Conditions for using this data asset.",
        message2: "Thank you for acknowledging the usage Terms & Conditions for this data set.",
        ackBtn: "I Acknowledge",
        cancelBtn: "Cancel",
        okBtn: "OK"
    },
    clientData: {
        PageType: {
            ShortName: "Client Data",
        },
        ClientDataAPIValues: {
            "defaultProvisionData": [
                {
                    "clientID": "60905206",
                    "clientName": "Bank of America",
                    "clientIndustrySector": "Consumer Products & Retail",
                    "clientIndustrySubsector": "CP&R",
                    "engagementID": "E-12436571",
                    "engagementName": "Banking Product",
                    "engagementCountry": "Netherlands",
                    "partnerName": "Jane J. Martinez",
                    "serviceLine": "ASU",
                    "subServiceLine": "Audit",
                    "dataSources": [
                        "tdf_si_a350bd4d40.60905206_43194317_sapuspii@adb-6166281744281984.4.azuredatabricks.net"
                    ]
                },
                {
                    "clientID": "123456789",
                    "clientName": "Bank of Asia",
                    "clientIndustrySector": "Banking & Retail",
                    "clientIndustrySubsector": "tbd - CP&R",
                    "engagementID": "E-12345678",
                    "engagementName": "Banking Product",
                    "engagementCountry": "Netherlands",
                    "partnerName": "Deepak D. Tagor",
                    "serviceLine": "ASU",
                    "subServiceLine": "Audit",
                    "dataSources": [
                        "tdf_si_a350bd4d40.60905206_43194317_sapuspii@adb-6166281744281984.4.azuredatabricks.net"
                    ]

                }
            ],
            "broaderUseData": [
                {
                    "clientID": "60905206",
                    "clientName": "Test Client Name",
                    "clientIndustrySector": "Consumer",
                    "clientIndustrySubsector": "Retail",
                    "engagementID": "EMEIA",
                    "engagementName": "Test Engagement",
                    "engagementCountry": "Netherlands",
                    "engagementPartner": "Test Partner Name ",
                    "serviceLine": "Consulting",
                    "subServiceLine": "Supply Chain and Operations",
                    "serviceOffering": "ABC",
                    "engagementArea": "PQR",
                    "tdfDatasetID": "b5cdec85-f1b1-98a3-db55-7eff",
                    "userAttested": false,
                    "dataSources": [
                        "tdf_si_afa.1001_1001_dq@adb-4296561161533013.13.azuredatabricks.net",
                        "adb_ops_db.1001_1001_dq@adb-4296561161533013.13.azuredatabricks.net"
                    ]
                },
                {
                    "clientID": "123456789",
                    "clientName": "Bank of Canada",
                    "clientIndustrySector": "Banking",
                    "clientIndustrySubsector": "Insurance",
                    "engagementID": "EMEIA",
                    "engagementName": "Test Engagement",
                    "engagementCountry": "Netherlands",
                    "engagementPartner": "Test Partner Name ",
                    "serviceLine": "ASU",
                    "subServiceLine": "Audit",
                    "serviceOffering": "XYZ",
                    "engagementArea": "DEF",
                    "tdfDatasetID": "a9bdec85-f1b1-98a3-db55-7eff",
                    "userAttested": false,
                    "dataSources": [
                        "tdf_si_afa.1001_1001_dq@adb-4296561161533013.13.azuredatabricks.net",
                        "adb_ops_db.1001_1001_dq@adb-4296561161533013.13.azuredatabricks.net"
                    ]
                }
            ],
        }
    },

    detailPageCDConfiguration: {
        "isEYPValidUser": false,
        "DiscoverSiteUrl": "https://find.eydev.net/Discover/",
        "FooterConfiguration": {
            "footerLinks": [
                {
                    "title": "Suggest Sources",
                    "url": "https://find.eydev.net/Discover/SitePages/Suggested.aspx?detailPath=XPPFUF5AFWHY-774269102-949#detailPath=XPPFUF5AFWHY-774269102-949",
                    "openInNewTab": true,
                    "id": "submitContent"
                },
                {
                    "title": "Data Guidance",
                    "url": "https://go.ey.com/3ATLzUC",
                    "openInNewTab": false,
                    "id": "glossary"
                },
                {
                    "title": "glossary",
                    "url": "https://data-dev.discover.ey.com/#/glossary",
                    "openInNewTab": false,
                    "id": "glossary"
                },
                {
                    "title": "feedback",
                    "url": "mailto:discover.team@ey.com?Subject=Feedback on Discover search&amp;body=https%3A%2F%2Fgo.ey.com%2F3nfJmwg",
                    "openInNewTab": false,
                    "id": "feedback"
                },
                {
                    "title": "support",
                    "url": "http://chs.ey.net/servlet/CHSRenderingServlet?draftMode=Y&chsReplicaID=852576F00003462C&contentID=LP-A5950769201461E985257F2A00357F83",
                    "openInNewTab": false,
                    "id": "support"
                }
            ],
            "generalConfig": {
                "logo": {
                    "url": "https://find.ey.net/discover",
                    "openInNewTab": false
                },
                "eyKnowledge": {
                    "url": "https://find.eydev.net/Discover/SitePages/Suggested.aspx",
                    "openInNewTab": false
                },
                "footerText": "EY does not intentionally collect any sensitive personal data from you via Discover Search. Discover Search’s intention is not to process such information.<br/>Accordingly, we request that you please do not enter sensitive personal data in your searches. <a style='color: #ffe600;' href='https://find.ey.net/discover/sitepages/home.aspx?detailPath=ZYFCSFS674FF-1228837741-3244#detailPath=ZYFCSFS674FF-1228837741-3244'> Terms of Use</a>"
            }
        },
        "menuConfiguration": [
            {
                "mainMenu": "SERVICE LINES",
                "openInNewTab": false,
                "url": "",
                "subMenu": [
                    {
                        "title": "Assurance",
                        "link": "https://sites.ey.com/sites/DS_Assurance",
                        "newTab": false,
                        "subMenuOrder": "1",
                        "siteCategory": "Service-Line",
                        "topics": ""
                    },
                    {
                        "title": "Consulting",
                        "link": "https://sites.ey.com/sites/DS_Consulting",
                        "newTab": false,
                        "subMenuOrder": "2",
                        "siteCategory": "Service-Line",
                        "topics": ""
                    },
                    {
                        "title": "Strategy and Transactions",
                        "link": "https://sites.ey.com/sites/DS_SaT",
                        "newTab": false,
                        "subMenuOrder": "3",
                        "siteCategory": "Service-Line",
                        "topics": ""
                    },
                    {
                        "title": "Tax",
                        "link": "https://sites.ey.com/sites/DS_Tax",
                        "newTab": false,
                        "subMenuOrder": "4",
                        "siteCategory": "Service-Line",
                        "topics": ""
                    }
                ],
                "id": "service"
            },
            {
                "mainMenu": "SECTORS",
                "openInNewTab": false,
                "url": "",
                "subMenu": [
                    {
                        "title": "Advanced Manufacturing & Mobility",
                        "link": "https://sites.ey.com/sites/DS_AMM",
                        "newTab": false,
                        "subMenuOrder": "1",
                        "siteCategory": "Sector-Line",
                        "topics": ""
                    },
                    {
                        "title": "Consumer",
                        "link": "https://sites.ey.com/sites/DS_CPR",
                        "newTab": false,
                        "subMenuOrder": "2",
                        "siteCategory": "Sector-Line",
                        "topics": ""
                    },
                    {
                        "title": "Financial Services (FS)",
                        "link": "https://sites.ey.com/sites/DS_FS",
                        "newTab": false,
                        "subMenuOrder": "3",
                        "siteCategory": "Sector-Line",
                        "topics": ""
                    },
                    {
                        "title": "FS: Banking & Capital Markets",
                        "link": "https://sites.ey.com/sites/DS_BCM",
                        "newTab": false,
                        "subMenuOrder": "4",
                        "siteCategory": "Sector-Line",
                        "topics": ""
                    },
                    {
                        "title": "FS: Insurance",
                        "link": "https://sites.ey.com/sites/DS_Insurance",
                        "newTab": false,
                        "subMenuOrder": "5",
                        "siteCategory": "Sector-Line",
                        "topics": ""
                    },
                    {
                        "title": "FS: Wealth & Asset Management",
                        "link": "https://sites.ey.com/sites/DS_WAM",
                        "newTab": false,
                        "subMenuOrder": "6",
                        "siteCategory": "Sector-Line",
                        "topics": ""
                    },
                    {
                        "title": "Government & Public Sector",
                        "link": "https://sites.ey.com/sites/DS_GPS",
                        "newTab": false,
                        "subMenuOrder": "7",
                        "siteCategory": "Sector-Line",
                        "topics": ""
                    },
                    {
                        "title": "Health Sciences & Wellness",
                        "link": "https://sites.ey.com/sites/DS_HSW",
                        "newTab": false,
                        "subMenuOrder": "8",
                        "siteCategory": "Sector-Line",
                        "topics": ""
                    },
                    {
                        "title": "Mining & Metals",
                        "link": "https://sites.ey.com/sites/DS_MM",
                        "newTab": false,
                        "subMenuOrder": "10",
                        "siteCategory": "Sector-Line",
                        "topics": ""
                    },
                    {
                        "title": "Oil & Gas",
                        "link": "https://sites.ey.com/sites/DS_OG",
                        "newTab": false,
                        "subMenuOrder": "11",
                        "siteCategory": "Sector-Line",
                        "topics": ""
                    },
                    {
                        "title": "Power & Utilities",
                        "link": "https://sites.ey.com/sites/DS_PU",
                        "newTab": false,
                        "subMenuOrder": "12",
                        "siteCategory": "Sector-Line",
                        "topics": ""
                    },
                    {
                        "title": "Private Equity",
                        "link": "https://sites.ey.com/sites/DS_pe",
                        "newTab": false,
                        "subMenuOrder": "13",
                        "siteCategory": "Sector-Line",
                        "topics": ""
                    },
                    {
                        "title": "Technology, Media & Entertainment, Telecommunications (TMT)",
                        "link": "https://sites.ey.com/sites/DS_TMT",
                        "newTab": false,
                        "subMenuOrder": "15",
                        "siteCategory": "Sector-Line",
                        "topics": ""
                    }
                ],
                "id": "sectors"
            },
            {
                "mainMenu": "TOPICS",
                "openInNewTab": false,
                "url": "",
                "subMenu": [
                    {
                        "title": "Artificial Intelligence (AI)",
                        "link": "https://sites.ey.com/sites/DS_WITM/Pages/artificial-intelligence.aspx",
                        "newTab": false,
                        "subMenuOrder": "1",
                        "siteCategory": "Topics",
                        "topics": ""
                    },
                    {
                        "title": "EY Partner Ecosystem",
                        "link": "https://sites.ey.com/sites/DS_SR",
                        "newTab": false,
                        "subMenuOrder": "2",
                        "siteCategory": "Topics",
                        "topics": "EY Partner Ecosystem"
                    },
                    {
                        "title": "EY Private",
                        "link": "https://sites.ey.com/sites/DS_EY-Private",
                        "newTab": false,
                        "subMenuOrder": "3",
                        "siteCategory": "Topics",
                        "topics": "EY Private"
                    },
                    {
                        "title": "EY Sustainability",
                        "link": "https://sites.ey.com/sites/DS_EY-Sustainability",
                        "newTab": false,
                        "subMenuOrder": "3",
                        "siteCategory": "Topics",
                        "topics": "EY Sustainability"
                    },
                    {
                        "title": "Long-Term Value",
                        "link": "https://sites.ey.com/sites/DS_LTV",
                        "newTab": false,
                        "subMenuOrder": "4",
                        "siteCategory": "Topics",
                        "topics": "Long-Term Value"
                    },
                    {
                        "title": "Managed Services",
                        "link": "https://sites.ey.com/sites/DS_MS",
                        "newTab": false,
                        "subMenuOrder": "5",
                        "siteCategory": "Topics",
                        "topics": "Managed Services"
                    },
                    {
                        "title": "Risk Management",
                        "link": "https://sites.ey.com/sites/DS_RM",
                        "newTab": false,
                        "subMenuOrder": "6",
                        "siteCategory": "Topics",
                        "topics": "Risk Management"
                    },
                    {
                        "title": "Winning in the market",
                        "link": "https://sites.ey.com/sites/DS_WITM",
                        "newTab": false,
                        "subMenuOrder": "7",
                        "siteCategory": "Topics",
                        "topics": "Winning in the Market"
                    }
                ],
                "id": "topics"
            },
            {
                "mainMenu": "SOLUTIONS",
                "openInNewTab": false,
                "url": "https://find.eydev.net/Discover/SitePages/solution.aspx",
                "subMenu": [],
                "id": "solutions"
            },
            {
                "mainMenu": "Data",
                "openInNewTab": false,
                "url": "https://data-dev.discover.ey.com/#/home",
                "subMenu": [],
                "id": "data"
            },
            {
                "mainMenu": "POLICIES ",
                "openInNewTab": false,
                "url": "https://eycloudappdev.sharepoint.com/sites/DS_RM/Pages/Policy.aspx",
                "subMenu": [],
                "id": "policy"
            },
            {
                "mainMenu": "EY-P",
                "openInNewTab": false,
                "url": "https://find.eydev.net/Discover/SitePages/cases.aspx",
                "subMenu": [],
                "id": "ey-p"
            },
            {
                "mainMenu": "Submit",
                "openInNewTab": false,
                "url": "https://discover-share.eydev.net/",
                "subMenu": [],
                "id": "submit"
            }
        ],
        "submit": "",
        "headerLogo": {
            "url": "https://find.eydev.net/discover",
            "openInNewTab": false
        },
        "apps": [
            {
                "title": "ONEDRIVE",
                "url": "https://data-dev.discover.ey.com/#/home",
                "openInNewTab": false,
                "id": "oneDrive"
            },
            {
                "title": "FOLLOWED SITES",
                "url": "https://data-dev.discover.ey.com/#/home",
                "openInNewTab": false,
                "id": "followedSites"
            }
        ],
        "PageConfiguration": {
            "cardSettings": {
                "statusStyle": [
                    {
                        "status": "Licensed - Global Enterprise Testing for long sentence behavior ",
                        "color": "rgb(255, 255, 255)",
                        "backgroundColor": "#168736"
                    },
                    {
                        "status": "Licensed - Restricted",
                        "color": "rgb(255, 255, 255)",
                        "backgroundColor": "#DA5800"
                    },
                    {
                        "status": "Unlicensed",
                        "color": "rgb(255, 255, 255)",
                        "backgroundColor": "rgb(128, 54, 0)"
                    },
                    {
                        "status": "Expiring soon",
                        "color": "rgb(255,255,255)",
                        "backgroundColor": "rgb(255, 65, 54)"
                    },
                    {
                        "status": "Open Data",
                        "color": "rgb(255, 255, 255)",
                        "backgroundColor": "rgb(18, 106, 171)"
                    },
                    {
                        "status": "N/A",
                        "color": "rgb(255, 255, 255)",
                        "backgroundColor": "rgb(116, 116, 128)"
                    },
                    {
                        "status": "Expired License",
                        "color": "rgb(255, 255, 255)",
                        "backgroundColor": "rgb(230, 12, 0)"
                    },
                    {
                        "status": "default",
                        "color": "rgb(255, 255, 255)",
                        "backgroundColor": "#168736"
                    },
                    {
                        "status": "License not required",
                        "color": "rgb(255, 255, 255)",
                        "backgroundColor": "rgb(29, 129, 126)"
                    }
                ],
                "essentailsCardCount": 3,
                "mostPopularCardCount": 4,
                "recentlyViewedCardCount": 4,
                "topicCardCount": 4
            }
        },
        "RefinerConfiguration": {
            "homePage": {
                "refiners": [
                    {
                        "displayProperty": "EYKDTopics",
                        "displayText": "Topic",
                        "dataType": "Text",
                        "description": "this is topic sectionthis is topic section this is topic section this is topic section this is topic section this is topic section this is topic section this is topic section this is topic section this is topic section this is topic section this is topic section this is topic section this is topic section"
                    },
                    {
                        "displayProperty": "owstaxIdEYKDCategory",
                        "displayText": "Category",
                        "dataType": "ManagedMetadata",
                        "description": "this is category section"
                    },
                    {
                        "displayProperty": "owstaxIdEYKDSector",
                        "displayText": "Sector",
                        "dataType": "ManagedMetadata",
                        "description": "this is Sector section"
                    },
                    {
                        "displayProperty": "owstaxIdEYKDServiceLine",
                        "displayText": "Service Line",
                        "dataType": "ManagedMetadata",
                        "description": "this is service section"
                    },
                    {
                        "displayProperty": "owstaxIdEYKDGeoAccess",
                        "displayText": "Geo Access",
                        "dataType": "ManagedMetadata",
                        "description": "this is geo access section"
                    },
                    {
                        "displayProperty": "owstaxIdEYKDGeoScope",
                        "displayText": "Geo Scope",
                        "dataType": "ManagedMetadata",
                        "description": "this is geo scope section"
                    },
                    {
                        "displayProperty": "EYKDAssetType",
                        "displayText": "Asset Type",
                        "dataType": "Text",
                        "description": "this is Asset section"
                    },
                    {
                        "displayProperty": "EYKDLicenseStatus",
                        "displayText": "License",
                        "dataType": "Text",
                        "description": "this is License section"
                    },
                    {
                        "displayProperty": "EYKDDataDelivery",
                        "displayText": "Data Delivery",
                        "dataType": "Text",
                        "description": "this is Data Delivery section"
                    }
                ]
            },
            "resultsPage": {
                "refiners": [
                    {
                        "displayProperty": "EYKDTopics",
                        "displayText": "Topic",
                        "dataType": "Text",
                        "description": "this is topic section"
                    },
                    {
                        "displayProperty": "owstaxIdEYKDCategory",
                        "displayText": "Category",
                        "dataType": "ManagedMetadata",
                        "description": "this is category section"
                    },
                    {
                        "displayProperty": "owstaxIdEYKDSector",
                        "displayText": "Sector",
                        "dataType": "ManagedMetadata",
                        "description": "this is Sector section"
                    },
                    {
                        "displayProperty": "owstaxIdEYKDServiceLine",
                        "displayText": "Service Line",
                        "dataType": "ManagedMetadata",
                        "description": "this is service section"
                    },
                    {
                        "displayProperty": "owstaxIdEYKDGeoAccess",
                        "displayText": "Geo Access",
                        "dataType": "ManagedMetadata",
                        "description": "this is geo access section"
                    },
                    {
                        "displayProperty": "owstaxIdEYKDGeoScope",
                        "displayText": "Geo Scope",
                        "dataType": "ManagedMetadata",
                        "description": "this is geo scope section"
                    },
                    {
                        "displayProperty": "EYKDAssetType",
                        "displayText": "Asset Type",
                        "dataType": "Text",
                        "description": "this is Asset section"
                    },
                    {
                        "displayProperty": "EYKDLicenseStatus",
                        "displayText": "License",
                        "dataType": "Text",
                        "description": "this is License section"
                    },
                    {
                        "displayProperty": "EYKDDataDelivery",
                        "displayText": "Data Delivery",
                        "dataType": "Text",
                        "description": "this is Data Delivery section"
                    }
                ]
            }
        },
        "DetailPageConfigurationCD": {
            "DefaultProvisionPage": {
                "entity": {
                    "dataProvider": {
                        "contentMinHeight": "213",
                        "detail": {
                            "banner": {
                                "defaultImageURL": "https://eunpinth6csta01.blob.core.windows.net/discoverdata/assets/images/Data%20Provider/detail_page_image.jpg"
                            },
                            "tabs": [
                                {
                                    "tabName": "Summary",
                                    "id": "summary",
                                    "showViewMoreAt": "30",
                                    "sections": [
                                        {
                                            "title": "Summary",
                                            "displayProperty": "",
                                            "sectionType": "default",
                                            "subSections": {
                                                "left": [
                                                    {
                                                        "title": "",
                                                        "displayProperty": "EYKDDescription"
                                                    },
                                                    {
                                                        "title": "Support",
                                                        "displayProperty": "EYKDSupport"
                                                    },
                                                    {
                                                        "title": "Online resources",
                                                        "displayProperty": "EYKDOnlineResources"
                                                    }
                                                ]
                                            }
                                        }
                                    ]
                                },
                                {
                                    "tabName": "How data can be used",
                                    "id": "data_can_be_used",
                                    "showViewMoreAt": "50",
                                    "sections": [
                                        {
                                            "title": "How data can be used",
                                            "sectionType": "default",
                                            "subSections": {
                                                "left": [
                                                    {
                                                        "title": "Registration",
                                                        "displayProperty": "EYKDRegistration"
                                                    },
                                                    {
                                                        "title": "",
                                                        "displayProperty": "EYKDAccessInformation"
                                                    },
                                                    {
                                                        "title": "Copyright",
                                                        "displayProperty": "EYKDCopyright"
                                                    },
                                                    {
                                                        "title": "Internal Redistribution",
                                                        "displayProperty": "EYKDInternalRedistribution"
                                                    },
                                                    {
                                                        "title": "External Redistribution",
                                                        "displayProperty": "EYKDExternalRedistribution"
                                                    },
                                                    {
                                                        "title": "Restrictions and limitations",
                                                        "displayProperty": "EYKDRestrictions"
                                                    }
                                                ]
                                            }
                                        }
                                    ]
                                },
                                {
                                    "tabName": "Engagement",
                                    "id": "engagement",
                                    "showViewMoreAt": "30",
                                    "sections": [
                                        {
                                            "title": "Engagement",
                                            "displayProperty": "",
                                            "sectionType": "default",
                                            "subSections": {
                                                "left": [
                                                    {
                                                        "title": "engagement"
                                                    }
                                                ]
                                            }
                                        }
                                    ]
                                },
                                {
                                    "tabName": "Client",
                                    "id": "client",
                                    "showViewMoreAt": "30",
                                    "sections": [
                                        {
                                            "title": "Client",
                                            "sectionType": "default"
                                        }
                                    ]
                                },
                                {
                                    "tabName": "Tags",
                                    "id": "metadataCD",
                                    "sections": [
                                        {
                                            "title": "Tags",
                                            "sectionType": "data_table",
                                            "subSections": [
                                                {
                                                    "key": "industrysector",
                                                    "displayname": "Industry Sector",
                                                    "align": "left"
                                                },
                                                {
                                                    "key": "subsector",
                                                    "displayname": "Subsector",
                                                    "align": "left"
                                                },
                                                {
                                                    "key": "serviceline",
                                                    "displayname": "Service line",
                                                    "align": "left"
                                                },
                                                {
                                                    "key": "subserviceline",
                                                    "displayname": "Subservice line",
                                                    "align": "right"
                                                },
                                                {
                                                    "key": "country",
                                                    "displayname": "Country",
                                                    "align": "right"
                                                }
                                            ]
                                        }
                                    ]
                                }
                            ]
                        }
                    }
                }
            },
            "BroaderUsePage": {
                "entity": {
                    "dataProvider": {
                        "contentMinHeight": "213",
                        "detail": {
                            "banner": {
                                "defaultImageURL": "https://eunpinth6csta01.blob.core.windows.net/discoverdata/assets/images/Data%20Provider/detail_page_image.jpg"
                            },
                            "tabs": [
                                {
                                    "tabName": "Summary",
                                    "id": "summary",
                                    "showViewMoreAt": "30",
                                    "sections": [
                                        {
                                            "title": "Summary",
                                            "displayProperty": "",
                                            "sectionType": "default",
                                            "subSections": {
                                                "left": [
                                                    {
                                                        "title": "",
                                                        "displayProperty": "EYKDDescription"
                                                    },
                                                ]
                                            }
                                        }
                                    ]
                                },
                                {
                                    "tabName": "How data can be used",
                                    "id": "data_can_be_used",
                                    "showViewMoreAt": "50",
                                    "sections": [
                                        {
                                            "title": "How data can be used",
                                            "sectionType": "default",
                                            "subSections": {
                                                "left": [
                                                    {
                                                        "title": "Registration",
                                                        "displayProperty": "EYKDRegistration"
                                                    },
                                                    {
                                                        "title": "",
                                                        "displayProperty": "EYKDAccessInformation"
                                                    },
                                                    {
                                                        "title": "Copyright",
                                                        "displayProperty": "EYKDCopyright"
                                                    },
                                                    {
                                                        "title": "Internal Redistribution",
                                                        "displayProperty": "EYKDInternalRedistribution"
                                                    },
                                                    {
                                                        "title": "External Redistribution",
                                                        "displayProperty": "EYKDExternalRedistribution"
                                                    },
                                                    {
                                                        "title": "Restrictions and limitations",
                                                        "displayProperty": "EYKDRestrictions"
                                                    }
                                                ]
                                            }
                                        }
                                    ]
                                },
                                {
                                    "tabName": "Engagement",
                                    "id": "engagement",
                                    "showViewMoreAt": "30",
                                    "sections": [
                                        {
                                            "title": "Engagement",
                                            "displayProperty": "",
                                            "sectionType": "default",
                                            "subSections": {
                                                "left": [
                                                    {
                                                        "title": "engagement"
                                                    }
                                                ]
                                            }
                                        }
                                    ]
                                },
                                {
                                    "tabName": "Client",
                                    "id": "client",
                                    "showViewMoreAt": "30",
                                    "sections": [
                                        {
                                            "title": "Client",
                                            "sectionType": "default"
                                        }
                                    ]
                                },
                                {
                                    "tabName": "Tags",
                                    "id": "metadataCD",
                                    "sections": [
                                        {
                                            "title": "Tags",
                                            "sectionType": "data_table",
                                            "subSections": [
                                                {
                                                    "key": "industrysector",
                                                    "displayname": "Industry Sector",
                                                    "align": "left"
                                                },
                                                {
                                                    "key": "subsector",
                                                    "displayname": "Subsector",
                                                    "align": "left"
                                                },
                                                {
                                                    "key": "serviceline",
                                                    "displayname": "Service line",
                                                    "align": "left"
                                                },
                                                {
                                                    "key": "subserviceline",
                                                    "displayname": "Subservice line",
                                                    "align": "right"
                                                },
                                                {
                                                    "key": "area",
                                                    "displayname": "Area",
                                                    "align": "right"
                                                },
                                                {
                                                    "key": "country",
                                                    "displayname": "Country",
                                                    "align": "right"
                                                }
                                            ]
                                        }
                                    ]
                                }
                            ]
                        }
                    }
                }
            }
        },
        "UrlsToReplace": {
            "ImagePath": {
                "sasToken": "sv=2021-06-08&ss=bfqt&srt=sco&sp=rwdlacupiytfx&se=2023-09-14T23:59:48Z&st=2022-09-13T23:59:48Z&spr=https&sig=TQhlpy15XjRd6UBnMZlnvL8wDK0YPCp76Ryiooq9ML0%3D",
                "source": "https://eundinth59sta01.blob.core.windows.net",
                "destination": "https://discovercdn-dev.azureedge.net"
            }
        },
        "ProviderDisclaimer": "<p style=\"\n    color: rgb(255, 255, 255);\n    font-size: 14px;\n    font-style: italic;\n\">It is your responsibility to understand the nature of any client relationship between EY and the Data Provider. The disclaimer has been configured. </p>  <a href=\"http://gfis2008pdr3.iweb.ey.com/clientlookup/eycrt/main.asp\" style=\"\n    color: rgb(255, 230, 0);\n    font-weight: normal;\n    text-decoration: underline;\n\">(http://gfis2008pdr3.iweb.ey.com/clientlookup/eycrt/main.asp)</a>",
        "EnableSuggestions": "True",
        "CartComparisonPageConfiguration": {
            "compareLimit": 4,
            "columnLayout": [
                {
                    "title": "",
                    "displayProperty": "Title",
                    "id": "title"
                },
                {
                    "title": "Status",
                    "displayProperty": "EYKDLicenseStatus",
                    "id": "status"
                },
                {
                    "title": "Data Delivery",
                    "displayProperty": "EYKDDataDelivery",
                    "id": "dataDelivery"
                },
                {
                    "title": "Asset Type",
                    "displayProperty": "EYKDAssetType",
                    "id": "assetType"
                },
                {
                    "title": "Provider",
                    "displayProperty": "EYKDAssociatedDataProvider",
                    "id": "provider"
                },
                {
                    "title": "Access Status",
                    "displayProperty": "EYKDAccessButtonLabel",
                    "id": "accessStatus"
                },
                {
                    "title": "Summary",
                    "id": "summary"
                },
                {
                    "title": "Description",
                    "displayProperty": "EYKDDescription",
                    "id": "description",
                    "expandable": true,
                    "expanded": true
                },
                {
                    "title": "Solutions",
                    "displayProperty": "EYKDSolutions",
                    "id": "solutions",
                    "expandable": true
                },
                {
                    "title": "Learning Materials",
                    "displayProperty": "EYKDLearningMaterials",
                    "id": "learningMaterials",
                    "expandable": true
                },
                {
                    "title": "Support",
                    "displayProperty": "EYKDSupport",
                    "id": "support",
                    "expandable": true
                },
                {
                    "title": "Online Resources",
                    "displayProperty": "EYKDOnlineResources",
                    "id": "onlineResources",
                    "expandable": true
                },
                {
                    "title": "How data can be used",
                    "id": "howDataCanBeUsed"
                },
                {
                    "title": "Registration",
                    "displayProperty": "EYKDRegistration",
                    "id": "registration",
                    "expandable": true
                },
                {
                    "title": "Usage Terms & conditions",
                    "displayProperty": "EYKDAccessInformation",
                    "id": "accessInformation",
                    "expandable": true
                },
                {
                    "title": "Best practices and approved use cases",
                    "displayProperty": "EYKDBestPractisesUseCases",
                    "id": "bestPracticesAndApprovedUseCases",
                    "expandable": true
                },
                {
                    "title": "Copyright",
                    "displayProperty": "EYKDCopyright",
                    "id": "copyright",
                    "expandable": true
                },
                {
                    "title": "Internal Redistribution",
                    "displayProperty": "EYKDInternalRedistribution",
                    "id": "internalRedistribution",
                    "expandable": true
                },
                {
                    "title": "External Redistribution",
                    "displayProperty": "EYKDExternalRedistribution",
                    "id": "externalRedistribution",
                    "expandable": true
                },
                {
                    "title": "Restrictions and Limitations",
                    "displayProperty": "EYKDRestrictions",
                    "id": "restrictionsAndLimitations",
                    "expandable": true
                },
                {
                    "title": "Collateral Items",
                    "displayProperty": "EYKDCollateralID",
                    "id": "collaterals"
                },
                {
                    "title": "Associated Assets",
                    "displayProperty": "EYKDAssociatedDataAssetsID",
                    "id": "associated"
                },
                {
                    "title": "Tags",
                    "id": "tags",
                    "expandable": true,
                    "subSections": [
                        {
                            "title": "Topic",
                            "displayProperty": "EYKDTopics",
                            "id": "topic"
                        },
                        {
                            "title": "Country",
                            "displayProperty": "EYKDCountry",
                            "id": "country"
                        },
                        {
                            "title": "Category",
                            "displayProperty": "owstaxIdEYKDCategory",
                            "id": "category",
                            "dataType": "taxonomy"
                        },
                        {
                            "title": "Sector",
                            "displayProperty": "owstaxIdEYKDSector",
                            "id": "sector",
                            "dataType": "taxonomy"
                        },
                        {
                            "title": "Service Line",
                            "displayProperty": "owstaxIdEYKDServiceLine",
                            "id": "serviceLine",
                            "dataType": "taxonomy"
                        },
                        {
                            "title": "Geo Access",
                            "displayProperty": "owstaxIdEYKDGeoAccess",
                            "id": "geoAccess",
                            "dataType": "taxonomy"
                        },
                        {
                            "title": "Geo Scope",
                            "displayProperty": "owstaxIdEYKDGeoScope",
                            "id": "geoScope",
                            "dataType": "taxonomy"
                        },
                        {
                            "title": "Language",
                            "displayProperty": "owstaxIdEYKDLanguage",
                            "id": "language",
                            "dataType": "taxonomy"
                        },
                        {
                            "title": "Data Delivery",
                            "displayProperty": "EYKDDataDelivery",
                            "id": "dataDelivery"
                        },
                        {
                            "title": "Data Provider Type",
                            "displayProperty": "EYKDProviderType",
                            "id": "dataProviderType"
                        }
                    ]
                }
            ]
        },
        "CatalogueConfiguration": "[{ key: \"TDFDiscoverDataSets\",  defaultContactCategory:1  }]",
        "AssetPillsConfiguration": [
            {
                "name": "All",
                "alias": "All",
                "key": "",
                "order": 1,
                "dataType": "Text",
                "displayText": "Asset Type",
                "managedProperty": "EYKDAssetType",
                "defaultSelect": "Yes"
            },
            {
                "name": "Data Set",
                "alias": "",
                "key": "",
                "order": 2,
                "dataType": "Text",
                "displayText": "Asset Type",
                "managedProperty": "EYKDAssetType",
                "defaultSelect": "No"
            },
            {
                "name": "Data Product",
                "alias": "Products",
                "key": "",
                "order": 3,
                "dataType": "Text",
                "displayText": "Asset Type",
                "managedProperty": "EYKDAssetType",
                "defaultSelect": "No"
            },
            {
                "name": "Data Provider",
                "alias": "Providers",
                "key": "",
                "order": 4,
                "dataType": "Text",
                "displayText": "Asset Type",
                "managedProperty": "EYKDAssetType",
                "defaultSelect": "No"
            },
            {
                "name": "Data Model",
                "alias": "Models",
                "key": "",
                "order": 5,
                "dataType": "Text",
                "displayText": "Asset Type",
                "managedProperty": "EYKDAssetType",
                "defaultSelect": "No"
            }
        ],
        "TDFReviwers": {
            "CCEmailIds": "nivanthi.dedigama@gds.ey.com;anirudha.bhanudas.vikhe1@gds.ey.com",
            "FromEmailId": "p.discoversearch.1@ey.net"
        },

    },
};
export default content;
